import "./index.scss";
import { useEffect, useState } from "react";
import sunImage from "@/assets/img/address-name.png";
import useDetailData from "./useDetailData";
import api from "../../../../apis";
interface IProps {
  open: boolean;
  detailId: any;
  onClose: () => void;
}

const MapDetail = (props: IProps) => {
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const { open, detailId, onClose } = props;
  const detailInfo = useDetailData(detailId, open);
  console.log("-----------123");
  console.log(detailInfo);
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position);
          if (position) {
            setLatitude(position.coords.longitude);
            setLongitude(position.coords.latitude);
          }
        },
        (error) => {
          console.error("Error getting geolocation:", error);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, [latitude, longitude]);
  const handleOnMap = () => {
    console.log(123);
    window.open(
      `https://uri.amap.com/navigation?from=${latitude},${longitude},我的位置&to=${detailInfo?.bar_lat},${detailInfo?.bar_lon},${detailInfo?.name}&mode=driving&policy=1&src=mypage&coordinate=gaode&callnative=1`,
      "_blank"
    );
  };
  return open ? (
    <div className="detailWrap">
      <div className="banner">
        <div
          className="backPage"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <i
            className="iconfont icon-cuowubeifen"
            style={{ fontSize: "26px", color: "#d8d8d8" }}
          ></i>
        </div>
      </div>
      <div className="content">
        <div className="detailInfo">
          <div className="title">{detailInfo?.name}</div>
          <div className="info">
            <div>
              主营业务：{detailInfo?.zy_yewu ? detailInfo?.zy_yewu : "--"}
            </div>
          </div>
          <div className="detailBottom">
            <div>
              <div className="address">
                <i
                  className="iconfont icon-weizhi"
                  style={{ fontSize: "12px", marginRight: "8px" }}
                ></i>
                地址：{detailInfo?.address}
              </div>
              <div className="phone">
                <i
                  className="iconfont icon-dianhua"
                  style={{ fontSize: "12px", marginRight: "8px" }}
                ></i>
                电话：{detailInfo?.tel ? detailInfo?.tel : "--"}
              </div>
            </div>
            <i
              className="iconfont icon-ditu"
              onClick={handleOnMap}
              style={{ fontSize: "40px", color: "#27BB07", cursor: "pointer" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="imageList">
        {detailInfo?.imgurl_arr.map((item: any, index: number) => {
          return (
            <img
              key={index}
              src={"https://yunditu.gymlink.cn/yunditu/admin/" + item}
            ></img>
          );
        })}
      </div>
      {/* <div className="footer" onClick={handleOnClocIn}>
        打卡
      </div> */}
    </div>
  ) : null;
};

export default MapDetail;
